import localDB from "./localDB";

let GLOBAL = require('./globals');

const PaymentData = {
    async getCurrentPlan() {
        const response = await fetch(`${GLOBAL.BASE_URL}payment/current-plan`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async list(search, page) {
        const response = await fetch(`${GLOBAL.BASE_URL}payments?id=${search}&page=${page}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getPaymentData(plan_id) {
        const response = await fetch(`${GLOBAL.BASE_URL}pay/subscription?plan_id=${plan_id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getEpaycoData(ref_payco) {
        const response = await fetch(`${GLOBAL.BASE_URL}pay/response/${ref_payco}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default PaymentData;



// WEBPACK FOOTER //
// ./src/data/PaymentData.js